module.exports = {
  /* 01.General */
  "copy.right": "ลิขสิทธิ์",
  "general.copyright": "© Inverz Solutions Co., Ltd.",

  "unauthorized.title": "Unauthorized Access Attempt",
  "unauthorized.detail":
    "You are not authorized to view the page you are trying to access.",

  /* 02.User Login, Logout, Register */
  "user.login-title": "เข้าสู่ระบบด้วยบัญชีของคุณ",
  "user.register": "Register",
  "user.forgot-password": "ลืมรหัสผ่าน",
  "user.email": "อีเมล",
  "user.password": "รหัสผ่าน",
  "user.forgot-password-question": "ลืมรหัสผ่านใช่หรือไม่?",
  "user.fullname": "ชื่อ-นามสกุล",
  "user.login-button": "เข้าสู่ระบบ",
  "user.register-button": "REGISTER",
  "user.reset-password-button": "รีเซ็ต",
  "user.reset-password": "สร้างรหัสผ่านใหม่",
  "user.buy": "BUY",
  "user.username": "ชื่อผู้ใช้",
  "user.session": "เซสชันหมดอายุ",
  "user.please-lognin": "กรุณาเข้าสู่ระบบอีกครั้ง",
  "user.current-password": "รหัสผ่านปัจจุบัน",
  "user.new-password": "รหัสผ่านใหม่",
  "user.verify-password": "ยืนยันรหัสผ่าน",

  /* 03.Menu */
  "menu.dashboard": "สรุปข้อมูล",
  "menu.report": "รายงาน",
  "menu.rental": "การเช่า",
  "menu.asset": "ทรัพย์สิน",
  "menu.account": "บัญชี",
  "menu.bill": "ใบแจ้งหนี้ค่าเช่า",
  "menu.company": "โปรไฟล์บริษัท",
  "menu.asset-manage": "การจัดการทรัพย์สิน",
  "menu.cost": "ค่าบริการเช่าสาธารณูปโภค",
  "menu.user": "การจัดการผู้ใช้",
  "menu.user-management": "การจัดการผู้ใช้",
  "menu.setting": "การตั้งค่า",
  "menu.sales": "การขาย",
  "menu.home": "Home",
  "menu.app": "Home",
  "menu.dashboards": "สรุปข้อมูล",
  "menu.gogo": "Gogo",
  "menu.start": "Start",
  "menu.second-menu": "Second Menu",
  "menu.rental-report": "รายงานการจองการเช่า",
  "menu.sale-report": "รายงานการจองการขาย",
  "menu.revenue-report": "รายงานรายได้",
  "menu.guest": "แฟ้มข้อมูลผู้เข้าพัก",
  "menu.ui": "UI",
  "menu.charts": "Charts",
  "menu.chat": "Chat",
  "menu.survey": "Survey",
  "menu.todo": "Todo",
  "menu.search": "ค้นหา",
  "menu.docs": "Docs",
  "menu.blank-page": "Blank Page",

  /* 04.Error Page */
  "pages.error-title": "Ooops... looks like an error occurred!",
  "pages.error-code": "Error code",
  "pages.go-back-home": "GO BACK HOME",

  // user management //
  "permission.detail": "รายละเอียดสิทธิ์การเข้าถึง",
  "add.permission": "เพิ่มสิทธิ์การเข้าถึง",
  "edit.permission": "แก้ไขสิทธิ์การเข้าถึง",
  "permission.name": "ชื่อสิทธิ์การเข้าถึง",
  "permission.names": "ชื่อสิทธิ์การเข้าถึง",
  "Permission.feature": "คุณสมบัติ",
  "feature.view": "ดู",
  "feature.add": "เพิ่ม/แก้ไข",
  "feature.delete": "ลบ",

  "permission.delete": "ลบสิทธิ์การเข้าถึง",
  "delete.detail": "คุณต้องการลบสิทธิ์การเข้าถึงนี้หรือไม่?",
  owner: "เจ้าของ",
  "add.new": "เพิ่มใหม่",
  "add.user": "เพิ่มผู้ใช้",
  "input.firstName": "ชื่อ",
  "input.lastName": "นามสกุล",
  "input.gender": "เพศ",
  "btn.male": "ชาย",
  "btn.female": "หญิง",
  "btn.sale": "ขาย",
  "btn.rent": "เช่า",
  "input.permission": "สิทธิ์การเข้าถึง",
  "input.date": "วันเกิด",
  "input.email": "อีเมล",
  "input.nationality": "สัญชาติ",
  "input.mobile": "หมายเลขโทรศัพท์มือถือ",
  "input.address": "ที่อยู่",
  "user.detail": "รายละเอียดผู้ใช้",
  "account.user": "สิทธิ์การเข้าถึง:",
  "name.user": "ซาราห์ คอร์ทนีย์",
  "choise.permission": "ผู้จัดการ",
  "resend.email": "ส่งอีเมลยืนยันใหม่",
  "resend.detail": "คุณต้องการส่งอีเมลยืนยันนี้อีกครั้งหรือไม่?",
  "button.no": "ไม่",
  "button.close": "ปิด",
  "button.yes": "ใช่",
  "button.ok": "ตกลง",
  "button.edit": "แก้ไข",
  "button.back": "ย้อนกลับ",
  "create.password": "สร้างรหัสผ่าน",
  "reset.password": "รีเซ็ตรหัสผ่าน",
  "error.permission": "กรุณากรอกชื่อสิทธิ์การเข้าถึง",
  "Modal.delete.user": "ลบผู้ใช้",
  "text.delete.user": "คุณต้องการลบผู้ใช้นี้หรือไม่?",
  "input.passport": "หมายเลขบัตรประชาชน/หนังสือเดินทาง",
  "alert.permission": "อุ๊ปส์! ผู้ใช้นี้มีอยู่แล้ว",
  "alert.user": "อุ๊ปส์! ผู้ใช้นี้มีอยู่แล้ว",
  "alert.room": "อุ๊ปส์! ห้องนี้ใช้อยู่ครับ",
  "alert.asset": "อุ๊ปส์! มีการใช้สินทรัพย์นี้อยู่ครับ",
  "alert.user": "ไม่สามารถลบได้ เนื่องจากกำลังถูกใช้งานอยู่",
  alert: "คำเตือน !!!",
  "dropdown.select": "เลือก...",

  // company name //
  "company-name": "ชื่อบริษัท",
  "company.name": "ชื่อบริษัท(ภาษาไทย)",
  "company.name_en": "ชื่อบริษัท(English)",
  "company.information": "ข้อมูลบริษัท",
  "organization.information": "ข้อมูลองค์กร",
  "organization.name.thai": "ชื่อองค์กร(ภาษาไทย)",
  "organization.name.eng": "ชื่อองค์กร(English)",
  "organization.license": "หมายเลขใบอนุญาตองค์กร",
  "company.address": "ที่อยู่(ภาษาไทย)",
  "company.address.eng": "ที่อยู่(English)",
  "company.address2": "ที่อยู่ 2 (ภาษาไทย)",
  "company.address.eng2": "ที่อยู่ 2 (English)",
  "company.country": "ประเทศ",
  "company.province": "จังหวัด",
  "company.district": "อำเภอ",
  "company.subdistrict": "ตำบล",
  "company.postal": "รหัสไปรษณีย์",
  "company.website": "เว็บไซต์",
  "company.phone": "หมายเลขโทรศัพท์",
  "company.fex": "หมายเลขแฟกซ์",
  "company.room": "ห้อง/ขีดจำกัดทรัพย์สิน",
  "company.branch": "หมายเลขสาขา",
  "company.tax": "หมายเลขทะเบียนผู้เสียภาษี",
  "company.logo": "โลโก้บริษัท",
  "same.address": "เหมือนที่อยู่ขององค์กร",
  "upload.logo":
    "*ขนาดโลโก้: กว้าง 1280 px x สูง 720 px | ขนาดไฟล์อย่างน้อย 1 MB (ไฟล์: *.png)",
  "upload.logo_1": "อัปโหลดโลโก้",

  // company name //
  "add.asset": "เพิ่มทรัพย์สินใหม่",
  "edit.asset": "แก้ไขทรัพย์สิน",
  "add.asset-detail": "เพิ่มรายละเอียดทรัพย์สิน",
  "asset.type": "ประเภททรัพย์สิน",
  "asset.name": "ชื่อทรัพย์สิน",
  "google.map": "URL แผนที่ Google",
  "add.zone": "เพิ่มโซน",
  "add.floor": "เพิ่มชั้น",
  "gallery.upload": "อัปโหลดแกลเลอรี",
  "upload.file": "อัปโหลดไฟล์",
  "room.name": "ชื่อห้อง/ทรัพย์สิน",
  "heading.room": "รายการห้อง/ทรัพย์สิน",
  "room.detail": "รายละเอียดห้อง/ทรัพย์สิน",
  "data.validation": "ขออภัย ข้อมูลไม่พร้อมใช้งานในขณะนี้",
  "add.room": "เพิ่มห้อง/ทรัพย์สิน",
  "edit.room": "แก้ไขห้อง/ทรัพย์สิน",
  "building.zone": "โซน",
  "Floor.No": "หมายเลขชั้น",
  "Room.No": "บล็อก, บูธ, ที่ดิน(โฉนด), หมายเลขห้อง",
  "photo.upload": "อัปโหลดรูปภาพ",
  upload: "อัปโหลด",
  "qty.bedroom": "จำนวนห้องนอน",
  "Floor.Size": "ขนาดห้อง/ทรัพย์สิน",
  "qty.toilet": "จำนวนห้องน้ำ",
  "Facilities.heading": "สิ่งอำนวยความสะดวก",
  "fee.detail": "รายละเอียดค่าใช้จ่าย",
  "fee.item": "หมายเลขรายการค่าใช้จ่าย",
  "fee.type": "ประเภทค่าใช้จ่าย",
  "Price.month": "ราคาต่อเดือน",
  Price: "ราคา",
  "Price.year": "ราคาเฉพาะปี",
  "one-price": "การชำระราคาเดียว",
  "merge-price": "ชำระรวม",
  "No.price": "ไม่มีราคา",
  "company.head": "สำนักงานใหญ่",

  // Cost Of Utilities //
  "btn.electric": "การคำนวณไฟฟ้า",
  "btn.water": "การคำนวณน้ำ",
  "heading.cost": "กรุณากรอกแบบฟอร์มนี้เพื่อรับการประเมินราคา",
  "select.cost": "เลือกประเภททรัพย์สิน",
  "price.cost": "ราคา/หน่วย",
  "unit.cost": "หน่วย",
  "electricity.tariff": "การปรับอัตราค่าไฟฟ้า (Ft)",
  "btn.calculate": "คำนวณ",
  "btn.reset": "รีเซ็ตรูปแบบฟอร์ม",
  "Used.Energy": "พลังงานที่ลูกค้าใช้",
  "Used.eset": "พลังงานที่ลูกค้าใช้",
  "With.meter": "มีมิเตอร์",
  "without.meter": "ไม่มีมิเตอร์",
  "Electricity.Rate": "อัตราค่าไฟฟ้าแบบก้าวหน้า",
  "Water.tariff": "อัตราค่าน้ำ",
  "utility-type": "ประเภทสาธารณูปโภค",
  "create-invoice": "สร้างใบแจ้งหนี้",
  "edit-utilities": "แก้ไขสาธารณูปโภค",
  "add-utilities": "เพิ่มสาธารณูปโภค",

  // Asset Name //
  "asset.Name": "ชื่อทรัพย์สิน",
  "zone.delete": "ลบโซน",
  "zone.delete-use": "การแจ้งเตือน !!",
  "delete.zone": "คุณต้องการลบโซนนี้หรือไม่?",
  "delete-use.zone": "ขออภัย! โซนนี้กำลังใช้งานอยู่",
  "floor.delete": "ลบชั้น",
  "delete.floor": "คุณต้องการลบชั้นนี้หรือไม่?",
  "room.poperty": "รายละเอียดห้อง/ทรัพย์สิน",
  "google.map.name": "แผนที่ Google",
  "building.zone.name": "โซน : ",
  "floor.no.name": "หมายเลขชั้น : ",
  "unit.bedroom": "ห้อง",
  "start.from": "เริ่มจาก ",
  "crop.image": "ตัดรูปภาพ",
  "room.delete": "ลบห้อง/ทรัพย์สิน",
  "delete.rooms": "คุณต้องการลบห้อง/ทรัพย์สินนี้หรือไม่?",
  "delete.asset": "ลบทรัพย์สิน",
  "delete.asset-details": "คุณต้องการลบทรัพย์สินนี้หรือไม่?",
  toilet: "ห้องน้ำ",
  description: "คำอธิบาย",

  // button //
  "btn.addZone": "เพิ่มโซน",
  "btn.addFloor": "เพิ่มชั้น",
  "btn.map.setup": "ตั้งค่าแผนที่",
  "btn.Personal": "ข้อมูลส่วนบุคคล",
  "btn.payment": "ข้อมูลการชำระเงิน",
  "btn.Company": "ข้อมูลบริษัท",
  "btn.change": "เปลี่ยนรหัสผ่าน",
  "btn.logout": "ออกจากระบบ",
  "btn.close": "ปิด",
  "btn.adduser": "เพิ่มผู้ใช้",
  "btn.edit": "แก้ไข",
  "button.cancel": "ยกเลิก",
  "button.save": "บันทึก",
  "button.done": "เสร็จสิ้น",
  "button.next": "ถัดไป",
  "button.add.asset": "เพิ่มทรัพย์สิน",
  "add.fee.detail": "เพิ่มรายละเอียดค่าธรรมเนียม",
  "btn.reset.all": "รีเซ็ตทั้งหมด",
  "btn.edit.photo": "แก้ไขรูปภาพ",
  "btn.addnew": "เพิ่มใหม่",
  "btn.send": "ส่ง",
  "btn.extend-stay": "ขยายระยะเวลาเข้าพัก",
  "btn.finish": "เสร็จสิ้น",
  "btn.day": "รายวัน",
  "btn.month": "รายเดือน",
  "btn.year": "รายปี",
  "btn.submit": "ส่ง",
  "btn.selling": "ขายตอนนี้",
  "want-to-pay": "ต้องการชำระทุก",

  // Asset Name //
  "input.nickName": "ชื่อเล่น",
  "modal.edituser": "แก้ไขผู้ใช้",
  "modal.deletefee": "ลบค่าธรรมเนียม",
  "modal.mapsetup": "ตั้งค่าแผนที่",
  "modal.editasset": "แก้ไขทรัพย์สิน",
  "modal.editroom": "แก้ไขห้อง/ทรัพย์สิน",
  "delete.fee": "คุณต้องการลบค่าธรรมเนียมนี้หรือไม่?",

  // Warning Company
  "warning.organize.name.th": "กรุณากรอกชื่อองค์กร (ภาษาไทย).",
  "warning.organize.name.en": "กรุณากรอกชื่อองค์กร (ภาษาอังกฤษ).",
  "warning.organize.license": "กรุณากรอกหมายเลขใบอนุญาตองค์กร.",
  "warning.organize.address.th": "กรุณากรอกที่อยู่ขององค์กร (ภาษาไทย).",
  "warning.organize.address.en": "กรุณากรอกที่อยู่ขององค์กร (ภาษาอังกฤษ).",
  "warning.organize.country": "กรุณากรอกประเทศขององค์กร.",
  "warning.organize.province": "กรุณากรอกจังหวัดขององค์กร.",
  "warning.organize.district": "กรุณากรอกอำเภอขององค์กร.",
  "warning.organize.subdistrict": "กรุณากรอกตำบลขององค์กร.",
  "warning.organize.postalcode": "กรุณากรอกรหัสไปรษณีย์ขององค์กร.",
  "warning.organize.phone": "กรุณากรอกหมายเลขโทรศัพท์ขององค์กร.",
  "warning.organize.email": "กรุณากรอกอีเมลขององค์กร.",
  "warning.company.branch": "กรุณากรอกหมายเลขสาขา.",
  "warning.company.address.th": "กรุณากรอกที่อยู่ (ภาษาไทย).",
  "warning.company.address.en": "กรุณากรอกที่อยู่ (ภาษาอังกฤษ).",
  "warning.company.country": "กรุณากรอกประเทศ.",
  "warning.company.province": "กรุณากรอกจังหวัด.",
  "warning.company.district": "กรุณากรอกอำเภอ.",
  "warning.company.subdistrict": "กรุณากรอกตำบล.",
  "warning.company.postalcode": "กรุณากรอกรหัสไปรษณีย์.",

  // Warning Personal
  "warning.prefix": "กรุณาเลือกคำนำหน้าชื่อ.",
  "warning.first.name": "กรุณากรอกชื่อ.",
  "warning.last.name": "กรุณากรอกนามสกุล.",
  "warning.gender": "กรุณาเลือกเพศ.",
  "warning.date": "กรุณากรอกวันเกิด.",
  "warning.nationality": "กรุณาเลือกสัญชาติ.",
  "warning.email": "กรุณากรอกอีเมล.",
  "warning.id.passport": "กรุณากรอกหมายเลขบัตรประจำตัว/พาสปอร์ต.",
  "warning.address": "กรุณากรอกที่อยู่.",
  "warning.country": "กรุณาเลือกประเทศ.",
  "warning.province": "กรุณาเลือกจังหวัด.",
  "warning.district": "กรุณาเลือกอำเภอ.",
  "warning.subdistrict": "กรุณาเลือกตำบล.",
  "warning.postal": "กรุณากรอกรหัสไปรษณีย์.",
  "warning.mobile": "กรุณากรอกหมายเลขโทรศัพท์มือถือ.",
  "warning.permiss": "กรุณาเลือกสิทธิ์การเข้าถึง.",
  "warning.legal-type": "กรุณาเลือกประเภทของนิติบุคคล",
  "warning.company-name": "กรุณากรอกชื่อบริษัท",
  "warning.corporate-number": "กรุณากรอกหมายเลขนิติบุคคล",
  "warning.relationship": "กรุณาเลือกสถานภาพสมรส",

  // Warning Permission
  "warning.permission.name": "กรุณากรอกชื่อสิทธิ์การเข้าถึง.",
  "warning.asset.name": "กรุณากรอกชื่อสินทรัพย์.",
  "warning.asset.name-dropdown": "กรุณาเลือกชื่อสินทรัพย์.",
  "warning.asset.type": "กรุณาเลือกประเภทสินทรัพย์.",
  "warning.asset.map": "กรุณากรอก URL ของ Google Map.",
  "warning.room&property.name": "กรุณากรอกชื่อห้องหรือทรัพย์สิน.",
  "warning.block.no": "กรุณากรอกหมายเลขบล็อก, บูธ, ที่ดิน(โฉนด), หมายเลขห้อง.",
  "warning.block.duplicate": "หมายเลขบล็อกนี้มีอยู่แล้ว กรุณาใช้หมายเลขอื่น",
  "warning.block.no-dropdown":
    "กรุณาเลือกหมายเลขบล็อก, บูธ, ที่ดิน(โฉนด), หมายเลขห้อง.",
  "warning.zone": "กรุณาเลือกโซน.",
  "warning.floor": "กรุณาเลือกชั้น.",
  "warning.profile.room": "กรุณาเพิ่มโปรไฟล์.",
  "warning.gallery": "กรุณาเพิ่มแกลเลอรี.",
  "warning.room&property.size": "กรุณากรอกขนาดห้องหรือทรัพย์สิน.",
  "warning.qty.bedroom": "กรุณากรอกจำนวนห้องนอน.",
  "warning.qty.toilet": "กรุณากรอกจำนวนห้องน้ำ.",
  "warning.facilities": "กรุณาเลือกสิ่งอำนวยความสะดวก.",
  "warning.number-people": "กรุณากรอกจำนวนคน.",
  "warning.number-duedate": "กรุณากรอกวันกำหนด.",
  "warning.start-date": "กรุณาเลือกวันที่เริ่มต้น.",
  // "warning.dates": "Please select a date.",
  // "warning.payment-type": "Please select a payment type.",
  "warning.end-date": "กรุณาเลือกวันที่สิ้นสุด.",
  "warning.due-date": "กรุณาเลือกวันที่กำหนด.",
  "warning.upload-files-doc":
    "คำเตือน: ไม่แนะนำให้คุณอัพโหลดเอกสารที่ระบุตัวตนของคุณ, เช่น สำเนาบัตรประชาชน, หนังสือเดินทาง, และเอกสารที่เกี่ยวข้อง, เนื่องจากมีความเสี่ยงที่จะละเมิดพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562.",
  "warning.booking-team-sale": `หากคุณต้องการเปลี่ยนแปลงหรือต้องการข้อมูลเพิ่มเติม กรุณาติดต่อฝ่ายขาย คุณ `,
  "warning.date-expired": "สัญญาการเช่าหมดอายุแล้ว.",
  "warning.date-expireds": "สัญญาการเช่ากำลังจะหมดอายุ.",
  "warning.day-extend-stay": "กรุณากรอกจำนวนวัน.",
  "warning.price-extend-stay": "กรุณากรอกค่าธรรมเนียมเพิ่มเติม.",
  "warning.month-extend-stay": "กรุณากรอกจำนวนเดือน.",
  "warning.bank-name": "กรุณาเลือกชื่อธนาคาร.",
  "warning.account-name": "กรุณากรอกชื่อบัญชี.",
  "warning.account-number": "กรุณากรอกหมายเลขบัญชี.",
  "warning.dates": "กรุณาเลือกวันที่.",
  "warning.payment-type": "กรุณาเลือกประเภทการชำระเงิน.",
  "warning.remark": "กรุณาเลือกหมายเหตุ.",
  "warning.email-address": "อีเมลนี้มีผู้ใช้งานแล้ว.",
  "warning.price": "กรุณากรอกราคา.",
  "warning.subject": "กรุณากรอกหัวข้อ.",
  "warning.status": "กรุณากรอกสถานะ.",
  "warning.property-type": "กรุณาเลือกประเภททรัพย์สิน.",
  "warning.guest-name": "กรุณาเลือกชื่อแขก.",
  "warning.sale-team": "กรุณาเลือกทีมขาย",

  // Map setup
  "modal.mepsetup": "การตั้งค่ารูปแผนที่",
  "modal.add-mepsetup": "เพิ่มการตั้งค่ารูปแผนที่",
  "modal.edit-mepsetup": "แก้ไขการตั้งค่ารูปแผนที่",
  "select-zone-floor": "กรุณาเลือกโซนและชั้น",
  "btn-download": "ดาวน์โหลด",
  "mepsetup-detail": "รายละเอียดการตั้งค่ารูปแผนที่",
  "delete.map": "ลบการตั้งค่ารูปแผนที่",
  "delete-map-detail": "คุณต้องการลบแผนที่นี้หรือไม่?",

  // Rental
  "modal-gallery": "แกลเลอรี่",
  booking: "การจอง",
  "booking-no": "หมายเลขการจอง",
  list: "รายการ",
  map: "แผนที่",
  "search-zone": "โซน",
  "search-floor": "ชั้น",
  "head-modal-booking": "กระบวนการจอง",
  prefix: "คำนำหน้า",
  contact: "ติดต่อ",
  "number-people": "จำนวนคน",
  "start-date": "วันที่เริ่มต้น",
  "end-date": "วันที่สิ้นสุด",
  "send-email": "ส่งไปที่อีเมล",
  print: "พิมพ์",
  "btn-save-draft": "บันทึกเป็นร่าง",
  "btn-book-now": "จองตอนนี้",
  "delete-booking": "ลบร่างการจอง",
  "delete-booking-detail": "คุณต้องการลบร่างการจองนี้หรือไม่?",
  "delete-selling": "ลบร่างการซื้อนี้",
  "delete-selling-detail": "คุณต้องการลบร่างการซื้อนี้หรือไม่?",
  "cancle-booking": "ยกเลิกการจอง",
  "cancle-booking-detail": "คุณต้องการยกเลิกการจองนี้หรือไม่?",
  "finish-booking": "เสร็จสิ้นการจอง",
  "finish-booking-detail": "คุณต้องการให้การจองนี้เสร็จสิ้นหรือไม่?",
  "extend-stay-day": "จำนวนวันที่ต้องการขยาย?",
  "extend-stay-month": "จำนวนเดือนที่ต้องการขยาย?",
  "extend-stay-price": "ค่าธรรมเนียมเพิ่มเติม",
  "price-range": "ช่วงราคา",
  minimum: "ระยะเวลาการพักขั้นต่ำ",
  "total-zone": "จำนวนโซนทั้งหมด",
  "total-unit": "จำนวนห้องทั้งหมด",
  "total-floor": "จำนวนชั้นทั้งหมด",
  "permission-rent":
    "คุณต้องการติดต่อทนายความเพื่อร่างสัญญาเช่าหรือสัญญาทางกฎหมายอื่นๆ หรือไม่?",

  // Bill
  "document-no": "หมายเลขเอกสาร",
  "last-meter": "มิเตอร์เก่า",
  "new-meter": "มิเตอร์ใหม่",
  "total-price": "ราคารวม",
  "due-date": "วันที่ครบกำหนด",
  vat: "ภาษีมูลค่าเพิ่ม 7%",
  discounts: "ส่วนลด",
  remark: "หมายเหตุ",
  "bank-name": "ชื่อธนาคาร",
  "account-name": "ชื่อบัญชี",
  "account-number": "หมายเลขบัญชี",
  "qr-code": "การชำระเงินผ่าน QR",
  "grand-total": "ยอดรวมทั้งหมด",
  payment: "การชำระเงิน",
  "payment-type": "ประเภทการชำระเงิน",
  cash: "เงินสด",
  transfer: "การโอนเงิน",
  "debit-credit": "บัตรเดบิต / เครดิต",
  other: "อื่นๆ",
  date: "วันที่",
  receipt: "ใบเสร็จ",
  invoice: "ใบแจ้งหนี้",
  collector: "ผู้เก็บเงิน",
  payer: "ผู้จ่ายเงิน",
  "delete-invoice": "ลบใบแจ้งหนี้",
  "delete-invoice-detail": "คุณต้องการลบใบแจ้งหนี้นี้หรือไม่?",
  year: "ปี",
  month: "เดือน",
  day: "วัน",

  // Sale
  "head-modal-selling": "กระบวนการขาย",
  "buyer-infor": "ข้อมูลผู้ซื้อ",
  "contract-infor": "ข้อมูลสัญญา",
  "selling-confirm": "ยืนยันการขาย",
  "permission-sale":
    "คุณต้องการติดต่อทนายความเพื่อร่างสัญญาซื้อขายหรือข้อตกลงทางกฎหมายอื่นๆ หรือไม่?",
  "click-here": "คลิกที่นี่",
  "confirm-seller": "ยืนยันข้อมูลผู้ขาย",
  seller: "ผู้ขาย",
  "selling-date": "วันที่ขาย",
  "contract-date": "วันที่ทำสัญญา",
  "transfer-date": "วันที่โอนกรรมสิทธิ์",
  "on-process": "กำลังดำเนินการ",
  "change-transfer-date": "เปลี่ยนวันที่โอนกรรมสิทธิ์",
  "payment-term": "ระยะเวลาการชำระเงิน",
  "cancle-selling": "ยกเลิกการขาย",
  "payment-period": "ระยะเวลาการชำระเงิน",
  subject: "หัวข้อ",
  status: "สถานะ",
  paid: "ชำระแล้ว",
  dates: "วันที่",
  pending: "รอดำเนินการ",
  reason: "เหตุผล",
  show: "แสดง",
  entries: "รายการ",
  "no.": "หมายเลข",
  "guest-name": "ชื่อแขก",
  "rental-fee": "ค่าบริการเช่า",
  "grand-totals": "ยอดรวมทั้งหมด",
  "payment-method": "วิธีการชำระเงิน",
  "sale-no.": "หมายเลขการขาย",
  "payment-date": "วันที่ชำระเงิน",
  "booking-date": "วันที่จอง",
  "property-type": "ประเภททรัพย์สิน",

  // Dashboard
  "total-properties": "รวมทั้งหมด",
  "available-properties": "ทรัพย์สินที่ว่าง",
  "occupied-properties": "ทรัพย์สินนี้ถูกเช่าหมดแล้ว",
  "occupied-properties-sale": "ทรัพย์สินนี้ถูกขายหมดแล้ว",
  "booking-overview": "ภาพรวมการจอง",
  "to-day": "วันนี้",
  week: "สัปดาห์",
  "property-rent-statistic": "สถิติการเช่าทรัพย์สิน",
  "upcoming-booking": "การจองที่กำลังจะมาถึง",
  "upcoming-invoice": "ใบแจ้งหนี้ที่กำลังจะมาถึง",
  "property-rent": "การเช่าทรัพย์สิน",
  "property-sale": "การขายทรัพย์สิน",
  action: "การดำเนินการ",
  "selling-no": "หมายเลขการขาย",
  selling: "ทรัพย์สินที่ขายแล้ว",
  "sold-out": "สินค้าหมด",
  sold: "ขายแล้ว",
  "property-sale-statistic": "สถิติการขายทรัพย์สิน",
  "in-progress-status": "สถานะกำลังดำเนินการ",
  revenue: "รายได้",
  "filter-price": "กรองราคา",
  occupied: "ที่ถูกจอง",
  "issue-date": "วันที่ออก",
  "water-charge": "ค่าน้ำ",
  "elec-charge": "ค่าไฟฟ้า",
  document: "เอกสาร",
  awaiting: "รอการชำระเงิน",
  awaitings: "รอการชำระเงิน",
  zones: "โซน",
  units: "หน่วย",
  "booking-now": "จองตอนนี้",
  "available/vacant": "ว่าง",
  details: "รายละเอียด",
  "payment-details": "รายละเอียดการชำระเงิน",
  "related-document": "เอกสารที่เกี่ยวข้อง",
  "identity-confirmed": "ยืนยันตัวตนแล้ว",
  "send-mail": "ส่งอีเมล์",
  "warning.select-zone": "โปรดเพิ่มโซนหรือเลือกไม่มีโซน",
  "warning.select-floor": "โปรดเพิ่มชั้นหรือเลือกไม่มีชั้น",
  "no-information": "ไม่มีข้อมูล",
  "warning.add-room": "กรุณาเพิ่มห้อง/ทรัพย์สิน",
  "payment-plan": "แผนการชำระเงิน",
  thb: "บาท",
  months: "เดือน",
  "no-of-month": "จำนวนเดือน",
  number: "จำนวน",
  "month-year": "เดือน/ปี",
  "warning.zone-input": "กรุณากรอกชื่อโซน",
  "warning.floor-input": "กรุณากรอกชั้น",
  "upload-profile":
    "*ขนาดภาพ: กว้าง 100 px x สูง 100 px | อย่างน้อย 100 กิโลไบต์",
  "upload-profile-type": "(ไฟล์: *.png, *.jpg, *.jpeg, *.heic, *.heif.)",

  "gallery-asset":
    "*ขนาดรูปภาพ: อย่างน้อย 50 KB (ไฟล์: *.png, *.jpg, *.jpeg, *.heic, *.heif.)",
  "gallery-asset-type":
    "*ขนาดรูปภาพ: อย่างน้อย 50 KB (ไฟล์: *.png, *.jpg, *.jpeg.)",
  "upload-gallery": "อัปโหลดแกลเลอรี",
  "drag-and-drop": "ลากและวางไฟล์ที่นี่หรือคลิกเพื่อเลือกไฟล์",
  "duplicate-file": "ชื่อไฟล์ซ้ำกัน",
  "allowed-formats": "รูปแบบที่อนุญาต: .png, .jpg, .jpeg, .heic, .heif",
  "warning.size.img": "ขนาดรูปภาพต้องมากกว่า 50KB",
  "delete-success": "ลบเรียบร้อยแล้ว",

  "click-upload": "คลิกเพื่ออัพโหลดไฟล์ ลากและวางแผนที่",
  "file-size": "*ไฟล์รูปภาพ: *.png, *.jpg, *.jpeg, *.heic, *.heif",

  total: "ทั้งหมด",
  name: "ชื่อ",
  "invoice-no": "เลขที่ใบแจ้งหนี้",
  subjects: "เรื่อง",
  issuer: "ผู้ออก",
  recipient: "ผู้รับ",
  "receipt-no": "เลขที่ใบเสร็จรับเงิน",
  "select-year": "เลือกปี",
  "unit(s)": "หน่วย",
  "price-per-unit": "ราคาต่อหน่วย",

  "btn.selling-draft": "แบบร่างการขาย",
  "signed-agreement-document": "เอกสารข้อตกลงที่ลงนามแล้ว",
  "dont-have-agreement": "ไม่มีข้อตกลง",
  "add-agreement": "โปรดอัปโหลดไฟล์ข้อตกลง",
  "click-upload-file": "ลากไฟล์มาที่นี่หรือคลิกเพื่ออัปโหลด",
  "relates-document": "เอกสารที่เกี่ยวข้อง",

  "confirm-rent": "คำร้องขอทนาย",
  lessor: "ผู้ให้เช่า",
  bedrooms: "ห้องนอน",
  "thb-per-month": "บาทต่อเดือน",
  "cost-utilities": "ค่าสาธารณูปโภค",
  "booking-draft": "แบบร่างการจอง",
  "lessee-information": "ข้อมูลผู้เช่า",
  "rental-information": "ข้อมูลการเช่า",
  "booking-information": "การยืนยันการจอง",
  all: "ทั้งหมด",
  vacant: "ว่าง",
  "sales-team": "ทีมขาย",
  wait: "โปรดรอ..",
  "add-item": "กรุณากรอกรายการ",
  "btn-add-item": "เพิ่มรายการ",
  "marital-status": "สถานภาพสมรส",
  single: "โสด",
  married: "สมรส",
  "corporate-entity": "นิติบุคคล",
  "type-legal-entity": "ประเภทของนิติบุคคล",
  "corporate-registration-number": "หมายเลขนิติบุคคล",
  "registration-no": "หมายเลขทะเบียนนิติบุคคล",
  "head-contract-expired": "ยกเลิกสัญญาเช่าหรือขายทรัพย์สิน/ห้องนี้",
  "contract-expired":
    "ท่านต้องการยกเลิกสัญญาเช่าหรือขายทรัพย์สิน/ห้องนี้หรือไม่?",
  "contract-expired-next":
    "หากยกเลิกสัญญานี้ ท่านจะไม่สามารถดูข้อมูลของทรัพย์สิน/ห้องนี้ได้อีก",
  "limit-room": "ท่านได้ใช้สิทธิ์เพิ่มทรัพย์สินของท่านหมดแล้ว",
  responsible: "รับผิดชอบ",
  "merge-bill": "รวมบิล",
  "alert-utility": "กรุณากรอกข้อมูลมิเตอร์ก่อนออกใบแจ้งหนี้",
  "alert-merge": "กรุณาสร้างใบแจ้งหนี้ก่อนเลือกรวมใบแจ้งหนี้",

  "edit-invoice": "แก้ไขใบแจ้งหนี้",
  "edit-rental-fee": "กรณีเปลี่ยนแปลงค่าเช่า",
  "this-bill": "บิลนี้เท่านั้น",
  throughout: "ตลอดสัญญา",
  "alert-cost": "กรุณากดบันทึกหรือยกเลิกก่อนเปลี่ยนเดือน",
  "billing-cycle": "ถึงรอบบิลแล้ว",
  "still-more-left": "เหลืออีก",
  "revenue.type": "ประเภทรายได้",
  "payment-completed": "ชำระเงินเรียบร้อยแล้ว",
  "overdue-payment": "การชำระเงินล่าช้า",
};
